/**
 * TrackVision Annotation Service
 * Ground truth manual marking for biomechanics validation.
 */
import { AZURE } from './api';

const PREFIX = '/trackvision';

export async function getAnnotations(sessionId) {
  const { data } = await AZURE.get(`${PREFIX}/sessions/${sessionId}/annotations`);
  return data;
}

export async function createAnnotation(sessionId, annotation) {
  const { data } = await AZURE.post(`${PREFIX}/sessions/${sessionId}/annotations`, annotation);
  return data;
}

export async function updateAnnotation(annotationId, updates) {
  const { data } = await AZURE.put(`${PREFIX}/annotations/${annotationId}`, updates);
  return data;
}

export async function deleteAnnotation(annotationId) {
  const { data } = await AZURE.delete(`${PREFIX}/annotations/${annotationId}`);
  return data;
}

export async function bulkCreateAnnotations(sessionId, payload) {
  // payload: { fps, annotations: [...], tenant_id?, athlete_id?, created_by? }
  const { data } = await AZURE.post(`${PREFIX}/sessions/${sessionId}/annotations/bulk`, payload);
  return data;
}

export async function getAccuracyReport(sessionId) {
  const { data } = await AZURE.get(`${PREFIX}/sessions/${sessionId}/accuracy-report`);
  return data;
}

/**
 * Export annotations as JSON (client-side)
 */
export function exportAnnotationsJSON(sessionId, fps, annotations) {
  const payload = {
    session_id: sessionId,
    fps,
    exported_at: new Date().toISOString(),
    annotations: annotations.map(a => ({
      type: a.annotation_type,
      frame: a.frame_index,
      timestamp_ms: a.timestamp_ms,
      side: a.side || null,
      label: a.label || null,
      angle_deg: a.angle_deg || null,
      notes: a.notes || null,
    })),
  };
  const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `trackvision_annotations_session_${sessionId}.json`;
  a.click();
  URL.revokeObjectURL(url);
}
